import { render, staticRenderFns } from "./FieldGeneric.vue?vue&type=template&id=cb4c80be&"
import script from "./FieldGeneric.vue?vue&type=script&lang=js&"
export * from "./FieldGeneric.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports